import { Tooltip } from '@mantine/core'
import { getIrrigationStatusColors } from 'App/Map/_utils/getIrrigationStatusColors'
import { getIrrigationStatusLabel } from 'App/Map/_utils/getIrrigationStatusLabel'
import type { TIrrigationDeviceStatus } from 'App/Map/types'
import { IconDot } from 'components/icons/IconDot'
import { useState } from 'react'

export const EmitterStatus = ({ status }: { status: TIrrigationDeviceStatus }) => {
  const [isHovered, setIsHovered] = useState(false)
  const label = getIrrigationStatusLabel(status)
  const { backgroundColor } = getIrrigationStatusColors(status)

  return (
    <div
      css={{ position: 'relative', display: 'inline-block' }}
      onMouseOver={() => setIsHovered(true)}
      onMouseOut={() => setIsHovered(false)}
    >
      <Tooltip opened={isHovered} label={label} position="top" withArrow withinPortal>
        <div css={{ color: backgroundColor }}>
          <IconDot />
        </div>
      </Tooltip>
    </div>
  )
}
